import { useState } from "react";
import { getOidcConfig } from "@/config/auth";

export const useOidcTokenRefresh = () => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastRefreshResult, setLastRefreshResult] = useState<string>("");
  const [hasValidRefreshToken, setHasValidRefreshToken] = useState(false);

  const refreshAccessToken = async () => {
    setIsRefreshing(true);

    try {
      // doorkeeper標準の/oauth/tokenエンドポイントを使用
      const oidcConfig = getOidcConfig();
      const tokenEndpoint =
        oidcConfig.metadata?.token_endpoint || `${import.meta.env.VITE_OIDC_AUTHORITY}/oauth/token`;

      // refresh_token grantのリクエスト
      const formData = new URLSearchParams();
      formData.append("grant_type", "refresh_token");
      formData.append("client_id", import.meta.env.VITE_OIDC_CLIENT_ID);
      // refresh_tokenはサーバーサイドでクッキーから自動的に設定される

      const response = await fetch(tokenEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
        credentials: "include", // HTTPオンリークッキー(__refresh_token)を含めて送信
      });

      if (response.ok) {
        const data = await response.json();
        setAccessToken(data.access_token);
        setHasValidRefreshToken(true);
        setLastRefreshResult("✅ Refresh Success");

        return data.access_token;
      }

      // リフレッシュトークンが無効または期限切れの場合
      if (response.status === 401 || response.status === 400) {
        setAccessToken(null);
        setHasValidRefreshToken(false);
        setLastRefreshResult("❌ Refresh Token Invalid/Expired");
        console.log("❌ Refresh token is invalid or expired");
        return null;
      }

      const errorData = await response.json().catch(() => ({}));
      setAccessToken(null);
      setHasValidRefreshToken(false);
      setLastRefreshResult(`❌ Refresh Failed: ${response.status}`);
      console.log("Refresh failed:", errorData);
      return null;
    } catch (error) {
      console.error("Token refresh failed:", error);
      setAccessToken(null);
      setLastRefreshResult("❌ Refresh Network Error");
      return null;
    } finally {
      setIsRefreshing(false);
    }
  };

  return {
    accessToken,
    refreshAccessToken,
    isRefreshing,
    lastRefreshResult,
    hasValidRefreshToken,
  };
};
